var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11.637,
    viewBox: "0 0 16 11.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.612,7.251a1.138,1.138,0,0,0-1.617,0l-8.482,8.493L6.95,12.169a1.163,1.163,0,0,0-1.617,1.674L9.7,18.214a1.138,1.138,0,0,0,1.617,0l9.29-9.29a1.138,1.138,0,0,0,0-1.674Z",
    transform: "translate(-4.978 -6.914)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconWhite);
export default __webpack_public_path__ + "static/media/check-icon-white.4c70675cf87522a115130419b1de78b8.svg";
export { ForwardRef as ReactComponent };